<template>
  <div class="tw:flex" :class="type === 'mobile' ? 'tw:flex-col tw:gap-y-4' : 'tw:flex-row tw:gap-x-4'">
    <BaseTextField
      size="big"
      id="datefrom"
      type="month"
      aria-label="Date from"
      :value="from"
      :max="maxMonth"
      :min="minMonth"
      @onChange="updateFrom"
    />
    <BaseTextField
      size="big"
      id="dateto"
      :value="to"
      :min="from || minMonth"
      :max="maxMonth"
      type="month"
      aria-label="Date to"
      @onChange="updateTo"
    />
  </div>
</template>

<script setup>
import BaseTextField from '@/components/base/inputs/BaseTextField.vue'
import { computed } from 'vue'

const props = defineProps({
  type: String,
  from: String,
  to: String,
  minMonth: String,
  allowFuture: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['setCustomFromDate', 'setCustomToDate'])

const maxMonth = computed(() => {
  if (props.allowFuture) return undefined

  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
})

const updateFrom = value => {
  emit('setCustomFromDate', value)
  if (value && props.to && value > props.to) {
    updateTo(value)
  }
}

const updateTo = value => {
  emit('setCustomToDate', value)
}
</script>
